import Auth from '../modules/Authentication'
import {apiUrl} from '../variables/index'
import {handleErrors} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Events {
  constructor() {
    this.auth = new Auth()
  }

  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}events/`, {headers}).then(handleErrors)
  }
  calendars = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}calendars/`, {headers}).then(handleErrors)
    },
  }
  create = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}events/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  remove = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}events/`, {
      headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  update = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}events/`, {
      headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
}
